/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';
import moment from 'moment-timezone';
import { datePickerOutputToUnix } from 'libs/utils/helpers/datepicker';
import { nowUnixTimestamp } from 'libs/utils/time';

// Components
import Checkboxes from 'shared/ui/components/form-components/Checkboxes.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';

const __vue_script__ = {
    name: 'ReportExportForm',

    components: {
        Checkboxes,
        DatetimePicker
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        reportName: {
            type: String,
            required: true
        },

        showPlatforms: {
            type: Boolean,
            default: true
        },

        fields: {
            type: Array,
            default: () => []
        },

        submitSpy: {
            type: Number,
            default: 0
        },

        initialStartDate: {
            type: Date,
            default: null
        },
        initialEndDate: {
            type: Date,
            default: null
        },
        liveStreamId: {
            type: String,
            default: null
        },
        hideDates: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        const getStartOfDay = (momentDate) => momentDate.startOf('day').toDate();

        const exportFields = this.fields.filter(f => f.value).map(f => f.name);
        let startDate = getStartOfDay(moment.unix(get(this.event, 'description.start_time', this.event.created || 0)));
        let endDate = getStartOfDay(moment.unix(get(this.event, 'description.end_time', nowUnixTimestamp())));

        if (this.$utils.workspaces.notStarted(this.event)) {
            startDate = getStartOfDay(moment());
        } else if (this.$utils.workspaces.isLive(this.event)) {
            endDate = getStartOfDay(moment());
        }

        const twoYearsBeforeEnd = this.$utils.time.twoYearsBefore(endDate);
        if (startDate.getTime() < twoYearsBeforeEnd.getTime()) {
            startDate = twoYearsBeforeEnd;
        }

        const availablePlatforms = [{
            name: 'web',
            label: this.$t('general.platforms.web'),
            value: true
        }, {
            name: 'ios',
            label: this.$t('general.platforms.ios'),
            value: true
        }, {
            name: 'android',
            label: this.$t('general.platforms.android'),
            value: true
        }];

        const useTimePicker = this.initialStartDate && this.initialEndDate;
        return {
            availablePlatforms,
            exportFields,
            platforms: availablePlatforms.map(p => p.name),
            showMoreFields: false,
            useTimePicker,
            startDate: useTimePicker ? this.initialStartDate : startDate,
            endDate: useTimePicker ? this.initialEndDate : endDate,
            submitting: false
        };
    },

    watch: {
        startDate(date) {
            const twoYearsAfter = this.$utils.time.twoYearsAfter(date);
            if (this.endDate.getTime() > twoYearsAfter.getTime()) {
                this.endDate = twoYearsAfter;
            }
        },

        endDate(date) {
            const twoYearsBefore = this.$utils.time.twoYearsBefore(date);
            if (this.startDate.getTime() < twoYearsBefore.getTime()) {
                this.startDate = twoYearsBefore;
            }
        },

        submitting(value) {
            this.$emit('submitting', value);
        },

        submitSpy(value) {
            if (value) {
                this.submit();
            }
        }
    },

    methods: {
        async submit() {
            try {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;
                const valid = await this.$refs.form.validate();
                if (!valid) {
                    return;
                }

                const data = {
                    fields: this.exportFields,
                    start: this.useTimePicker ?
                        datePickerOutputToUnix(this.startDate, this.event.timezone) :
                        moment(this.startDate).format(this.$const.DEFAULT_DATE_FORMAT),
                    end: this.useTimePicker ?
                        datePickerOutputToUnix(this.endDate, this.event.timezone) :
                        moment(this.endDate).format(this.$const.DEFAULT_DATE_FORMAT),
                    liveStreamId: this.liveStreamId
                };

                if (this.showPlatforms) {
                    data.platforms = this.platforms;
                }

                console.info('[ReportExportForm] Sending an export request:', data);

                const task = await this.$services.analytics.requestReportByName(this.event._id, this.reportName, data);
                this.$emit('completed', task);

            } catch (error) {
                console.error('[ReportExportForm] An error occurred', error.message);
                this.$emit('error', error);

            } finally {
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"report-export-form",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submit)}}},[(!_vm.hideDates)?_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"start","mode":"passive"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{attrs:{"label":_vm.$t('analytics.exports.start'),"name":"start","errors":errors,"type":_vm.useTimePicker ? 'datetime' : 'date',"value-type":"date","not-after":_vm.endDate,"format":_vm.useTimePicker ? _vm.$const.DEFAULT_DATETIME_FORMAT : _vm.$const.DEFAULT_DATE_FORMAT},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"end","mode":"passive"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{attrs:{"label":_vm.$t('analytics.exports.end'),"name":"end","errors":errors,"type":_vm.useTimePicker ? 'datetime' : 'date',"value-type":"date","show-second":false,"not-before":_vm.startDate,"disabled":!_vm.startDate,"format":_vm.useTimePicker ? _vm.$const.DEFAULT_DATETIME_FORMAT : _vm.$const.DEFAULT_DATE_FORMAT},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})]}}],null,true)})],1):_vm._e(),(_vm.showPlatforms)?_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"platforms"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('checkboxes',{attrs:{"label":_vm.$t('analytics.exports.platforms'),"errors":errors,"options":_vm.availablePlatforms,"name":"platforms","inline":true},model:{value:(_vm.platforms),callback:function ($$v) {_vm.platforms=$$v},expression:"platforms"}})]}}],null,true)}):_vm._e(),(_vm.fields.length)?_c('div',{staticClass:"fields-list",class:{ full: _vm.showMoreFields }},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"fields"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('checkboxes',{attrs:{"label":_vm.$t('analytics.exports.fields'),"errors":errors,"options":_vm.fields,"name":"fields","tip":_vm.$t('analytics.exports.preselected_fields'),"inline":true,"itemised":true,"show-toggler":true},model:{value:(_vm.exportFields),callback:function ($$v) {_vm.exportFields=$$v},expression:"exportFields"}})]}}],null,true)}),_c('a',{staticClass:"has-action full-list-toggler",on:{"click":function($event){_vm.showMoreFields = !_vm.showMoreFields}}},[_vm._v(_vm._s(_vm.showMoreFields ? _vm.$t('general.show_less') : _vm.$t('general.show_more'))),_c('i',{staticClass:"ic-chevron-down"})])],1):_vm._e()],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ReportExportForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__